export const FETCH_DOC_LOCATOR = 'FETCH_DOC_LOCATOR';
export const FETCH_ACCOUNT_DOC_VERSION = 'FETCH_ACCOUNT_DOC_VERSION';
export const FETCH_DOC_FAILED = 'FETCH_DOC_FAIL'; //TODO - need to update once doc locator resolved
export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const FETCH_CONTENT = 'FETCH_CONTENT';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_FAILED = 'FETCH_FAILED';
export const FETCH_USER_BANKID = 'FETCH_USER_BANKID';
export const FETCH_USER_BANKID_SUCCESS = 'FETCH_USER_BANKID_SUCCESS';
export const FETCH_ACCOUNT_DETAILS = 'FETCH_ACCOUNT_DETAILS';
export const FETCH_ACCOUNT_DETAILS_SUCCESS = 'FETCH_ACCOUNT_DETAILS_SUCCESS';
export const FETCH_ACCOUNT_DETAILS_FAILED = 'FETCH_ACCOUNT_DETAILS_FAILED';

//redirect
export const REDIRECT_NEXT_SCREEN = 'REDIRECT_NEXT_SCREEN';
export const SELECTED_BRAND = 'SELECTED_BRAND';
export const NONE_SELECTED_BRAND = 'NONE_SELECTED_BRAND';
export const HAS_VM_ACCOUNT = 'HAS_VM_ACCOUNT';
export const HAS_OVERDRAFT_ACCOUNT = 'HAS_OVERDRAFT_ACCOUNT';
export const PERSONAL_FORM_FIELD = 'PERSONAL_FORM_FIELD';
export const ACCOUNT_TYPE = 'ACCOUNT_TYPE';
export const OTHER_ACCOUNT_HOLDER = 'OTHER_ACCOUNT_HOLDER';
export const EMPLOYMENT_FORM_FIELD = 'EMPLOYMENT_FORM_FIELD';
export const RESET_OCCUPATION = 'RESET_OCCUPATION';
export const INCOME_EXPENSE_FORM_FIELD = 'INCOME_EXPENSE_FORM_FIELD';
export const NAVIGATE_TO_EDIT_SCREEN = 'NAVIGATE_TO_EDIT_SCREEN';
export const GET_ADDRESS_DETAILS = 'GET_ADDRESS_DETAILS';
export const FETCH_ADDRESS_LIST_BY_POSTCODE = 'FETCH_ADDRESS_LIST_BY_POSTCODE';
export const FETCH_ADDRESS_BY_ID = 'FETCH_ADDRESS_BY_ID';
export const UPDATE_SELECTED_ADDRESS_SUCCESS = 'UPDATE_SELECTED_ADDRESS_SUCCESS';
export const DATE_MOVED = 'DATE_MOVED';
export const UPDATE_ADDRESS_LIST = 'UPDATE_ADDRESS_LIST';
export const ADDRESS_FORM_FIELD = 'ADDRESS_FORM_FIELD';
export const UPDATE_CURRENT_ADDRESS = 'UPDATE_CURRENT_ADDRESS';
export const HAS_PREVIOUS_ADDRESS = 'HAS_PREVIOUS_ADDRESS';
export const HAS_ANOTHER_PREVIOUS_ADDRESS = 'HAS_ANOTHER_PREVIOUS_ADDRESS';
export const PREVIOUS_ADDRESS_FORM_FIELD = 'PREVIOUS_ADDRESS_FORM_FIELD';
export const UPDATE_CUSTOMER_INFO = 'UPDATE_CUSTOMER_INFO';
export const UPDATE_PREVIOUS_MANUAL_ADDRESS = 'UPDATE_PREVIOUS_MANUAL_ADDRESS';
export const RESET_EDIT = 'RESET_EDIT';
export const UPDATE_CUSTOMER_PERSONAL_DETAILS = 'UPDATE_CUSTOMER_PERSONAL_DETAILS';
export const UPDATE_CUSTOMER_PERSONAL_DETAILS_SUCCESS = 'UPDATE_CUSTOMER_PERSONAL_DETAILS_SUCCESS';
export const UPDATE_PERSONAL_CUSTOMER = 'UPDATE_PERSONAL_CUSTOMER';
export const UPDATE_PERSONAL_CUSTOMER_SUCCESS = 'UPDATE_PERSONAL_CUSTOMER_SUCCESS';
export const SET_IS_PREVIOUS_ADDRESS_UK = 'SET_IS_PREVIOUS_ADDRESS_UK';
export const UPDATE_INTERNATIONAL_ADDRESS = 'UPDATE_INTERNATIONAL_ADDRESS';
//JOINT constant
export const SET_SECONDARY_JOURNEY = 'SET_SECONDARY_JOURNEY';
export const PERSONAL_SECONDARY_FORM_FIELD = 'PERSONAL_SECONDARY_FORM_FIELD';
export const EMPLOYMENT_SECONDARY_FORM_FIELD = 'EMPLOYMENT_SECONDARY_FORM_FIELD';
export const RESET_SECONDARY_OCCUPATION = 'RESET_SECONDARY_OCCUPATION';
export const INCOME_EXPENSE_SECONDARY_FORM_FIELD = 'INCOME_EXPENSE_SECONDARY_FORM_FIELD';
export const GET_SECONDARY_ADDRESS_DETAILS = 'GET_SECONDARY_ADDRESS_DETAILS';
export const FETCH_SECONDARY_ADDRESS_LIST_BY_POSTCODE = 'FETCH_SECONDARY_ADDRESS_LIST_BY_POSTCODE';
export const FETCH_SECONDARY_ADDRESS_BY_ID = 'FETCH_SECONDARY_ADDRESS_BY_ID';
export const UPDATE_SELECTED_SECONDARY_ADDRESS_SUCCESS =
  'UPDATE_SELECTED_SECONDARY_ADDRESS_SUCCESS';
export const DATE_SECONDARY_MOVED = 'DATE_SECONDARY_MOVED';
export const UPDATE_SECONDARY_ADDRESS_LIST = 'UPDATE_SECONDARY_ADDRESS_LIST';
export const ADDRESS_SECONDARY_FORM_FIELD = 'ADDRESS_SECONDARY_FORM_FIELD';
export const UPDATE_CURRENT_SECONDARY_ADDRESS = 'UPDATE_CURRENT_SECONDARY_ADDRESS';
export const HAS_PREVIOUS_SECONDARY_ADDRESS = 'HAS_PREVIOUS_SECONDARY_ADDRESS';
export const PREVIOUS_ADDRESS_SECONDARY_FORM_FIELD = 'PREVIOUS_ADDRESS_SECONDARY_FORM_FIELD';
export const UPDATE_PREVIOUS_MANUAL_SECONDARY_ADDRESS = 'UPDATE_PREVIOUS_MANUAL_SECONDARY_ADDRESS';
export const SET_ADDRESS_VIEW_MODE = 'SET_ADDRESS_VIEW_MODE';
export const REDIRECT_URL = 'REDIRECT_URL';
export const NAVIGATE_TO_BROCHUREWARE = 'NAVIGATE_TO_BROCHUREWARE';
export const RESET_VIEW_ADDRESS_FLAG = 'RESET_VIEW_ADDRESS_FLAG';
export const RESET_ADDRESS_POST_REMOVE = 'RESET_ADDRESS_POST_REMOVE';
export const RESET_ADDRESS_POST_REMOVE_SECONDARY = 'RESET_ADDRESS_POST_REMOVE_SECONDARY';
export const IS_ADDRESS_INTERNATIONAL_SECONDARY = 'IS_ADDRESS_INTERNATIONAL_SECONDARY';
export const HAS_ANOTHER_PREVIOUS_ADDRESS_SECONDARY = 'HAS_ANOTHER_PREVIOUS_ADDRESS_SECONDARY';
export const UPDATE_INTERNATIONAL_ADDRESS_SECONDARY = 'UPDATE_INTERNATIONAL_ADDRESS_SECONDARY';
export const REMOVE_SECONDARY_ADDRESS = 'REMOVE_SECONDARY_ADDRESS';
export const UPDATE_BACK_SCENARIO_FLAG = 'UPDATE_BACK_SCENARIO_FLAG';
export const REMOVE_POSTCODE_ADDRESSES = 'REMOVE_POSTCODE_ADDRESSES';
export const REMOVE_POSTCODE_SECONDARY_ADDRESSES = 'REMOVE_POSTCODE_SECONDARY_ADDRESSES';
export const SECONDARY_JOURNEY_COMPLETE = 'SECONDARY_JOURNEY_COMPLETE';

export const INITIATE_TRANSFER = 'INITIATE_TRANSFER';
export const TRANSFER_SUCCESS = 'TRANSFER_SUCCESS';
export const TRANSFER_FAILED = 'TRANSFER_FAILED';
export const CLEAR_FORM = 'CLEAR_FORM';

export const CAPTURE_EVIDENCE = 'CAPTURE_EVIDENCE';
export const CAPTURE_EVIDENCE_SUCCESS = 'CAPTURE_EVIDENCE_SUCCESS';
